// Indonesian labels for exercise taxonomy (categories, equipment, muscle groups).
const CATEGORY_ID = {
  all: "Semua", strength: "Kekuatan", hypertrophy: "Hipertrofi", cardio: "Kardio",
  hiit: "HIIT", mobility: "Mobilitas", yoga: "Yoga", sports: "Olahraga",
  core: "Inti", olympic: "Olimpik", machine: "Mesin", bodyweight: "Berat Badan",
};

const EQUIPMENT_ID = {
  barbell: "Barbel", dumbbell: "Dumbbell", machine: "Mesin", cable: "Kabel",
  bodyweight: "Berat Badan", kettlebell: "Kettlebell", band: "Resistance Band", other: "Lainnya",
};

const MUSCLE_ID = {
  Quadriceps: "Paha Depan", Quads: "Paha Depan", Glutes: "Bokong", Hamstrings: "Paha Belakang",
  Core: "Inti", Chest: "Dada", "Upper Chest": "Dada Atas", Triceps: "Trisep", Shoulders: "Bahu",
  Back: "Punggung", Lats: "Latissimus", Biceps: "Bisep", Forearms: "Lengan Bawah", Calves: "Betis",
  "Lower Back": "Punggung Bawah", "Side Delts": "Deltoid Samping", "Front Delts": "Deltoid Depan",
  "Rear Delts": "Deltoid Belakang", "Upper Back": "Punggung Atas", Obliques: "Otot Samping",
  "Hip Flexors": "Fleksor Pinggul", "Full Body": "Seluruh Tubuh", Legs: "Kaki",
  Spine: "Tulang Belakang", Thoracic: "Toraks", Hips: "Pinggul", Arms: "Lengan",
  Traps: "Trapesius", Neck: "Leher", Adductors: "Paha Dalam", Abductors: "Paha Luar", Abs: "Perut",
  Serratus: "Serratus", Cardio: "Kardiovaskular", Rhomboids: "Rhomboid", Brachialis: "Brakialis",
  Ankles: "Pergelangan Kaki", Feet: "Telapak Kaki", "Rotator Cuff": "Rotator Cuff", Soleus: "Soleus",
  Wrists: "Pergelangan Tangan", Grip: "Genggaman", Shins: "Tulang Kering",
};

export const MUSCLE_GROUPS = [
  { key: "chest", id: "Dada", en: "Chest" },
  { key: "back", id: "Punggung", en: "Back" },
  { key: "shoulders", id: "Bahu", en: "Shoulders" },
  { key: "arms", id: "Lengan", en: "Arms" },
  { key: "forearms", id: "Lengan Bawah", en: "Forearms" },
  { key: "legs", id: "Kaki", en: "Legs" },
  { key: "glutes", id: "Bokong", en: "Glutes" },
  { key: "calves", id: "Betis", en: "Calves" },
  { key: "abs", id: "Perut", en: "Abs" },
  { key: "cardio", id: "Kardio", en: "Cardio" },
  { key: "fullbody", id: "Seluruh Tubuh", en: "Full Body" },
];

export const EQUIPMENT_KEYS = ["all", "barbell", "dumbbell", "machine", "cable", "bodyweight", "kettlebell", "band", "other"];

export const DIFFICULTY_META = {
  beginner: { id: "Pemula", en: "Beginner", text: "text-emerald-600 dark:text-emerald-400", dot: "bg-emerald-500", on: "border-emerald-500 bg-emerald-500 text-white" },
  intermediate: { id: "Menengah", en: "Intermediate", text: "text-amber-600 dark:text-amber-400", dot: "bg-amber-500", on: "border-amber-500 bg-amber-500 text-white" },
  advanced: { id: "Mahir", en: "Advanced", text: "text-rose-600 dark:text-rose-400", dot: "bg-rose-500", on: "border-rose-500 bg-rose-500 text-white" },
};

const NON_PICKABLE = new Set(["Serratus", "Cardio", "Rhomboids", "Brachialis", "Ankles", "Feet", "Rotator Cuff", "Soleus", "Wrists", "Grip", "Shins"]);

export const txCategory = (v, lang) => (lang === "id" && CATEGORY_ID[v]) || v;
export const txEquipment = (v, lang) => (lang === "id" && EQUIPMENT_ID[v]) || v;
export const txMuscle = (v, lang) => (lang === "id" && MUSCLE_ID[v]) || v;
export const txMuscles = (arr, lang) => (arr || []).map((m) => txMuscle(m, lang)).join(", ");
export const MUSCLE_KEYS = Object.keys(MUSCLE_ID).filter((k) => !NON_PICKABLE.has(k));
